<template>
	<v-container>
		<v-page-header :color="$root.colorHeader" :titulo="$root.titleHeader" />

		<v-card tile>
			<v-card-title primary-title v-if="temFuncao('OBRAS_SALVAR')">
				<router-link to="novo" append tag="span">
					<v-tooltip :value="$root.showAtalhos" bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn v-bind="attrs" v-on="on">
								<v-icon color="primary">mdi-plus</v-icon> Nova Obra
							</v-btn>
						</template>
						<span v-shortkey.once="['alt', 'n']" @shortkey="novo">alt+n</span>
					</v-tooltip>
				</router-link>
			</v-card-title>

			<v-row class="ml-4 mr-4">

				<v-col md="8">
					<v-text-field
						outlined
						v-model="searchText"
						label="Pesquisa"
						clearable
						autofocus
					/>
				</v-col>
				
			</v-row>

			<v-data-table
				v-model="obrasSelecionadas"
				:headers="headers"
				:items="obras"
				class="elevation-1 row-pointer"
				@click:row="rowClick"
				:no-data-text="noDataMessage"
				:search="searchText"
				:items-per-page="itemsPerPage"
				:page.sync="page"
				:custom-sort="customSort"
				@pagination="p => (itemsPerPage = p.itemsPerPage)"
				:header-props="{
					sortByText: 'Ordenar por'
				}"
				:footer-props="{
					itemsPerPageText: 'Itens por página:',
					itemsPerPageAllText: 'Todos',
					itemsPerPageOptions: [10, 15, 25, 50, 100, -1]
				}"
				ref="tableObras"
				@snack="v => this.$emit('snack',v)"
			>
				<!-- <template v-slot:[`item.actions`]="{ item }">
					<v-btn
						color="primary"
						small
						@click="imprimirDecreto(item)"
					>
						Imprimir
					</v-btn>
				</template> -->
				<template
					v-slot:[`footer.page-text`]="{ pageStart, pageStop, itemsLength }"
				>
					Exibindo Página de
					{{ Math.floor((pageStart - 1) / itemsPerPage + 1) }} a
					{{ Math.floor(itemsLength / itemsPerPage) + 1 }} <br />
					Itens de {{ pageStart }} a {{ pageStop }} - Total: {{ itemsLength }}
				</template>
			</v-data-table>

		</v-card>
		
	</v-container>
</template>

<script>
// @ is an alias to /src
import VPageHeader from '@/components/PageHeader.vue';
import { parse as parseDate } from 'date-fns';

export default {
	name: 'Home',
	data() {
		return {
			searchText: null,
			obras: [],
			obrasSelecionadas: [],
			loading: false,
			headers: [
				{ text: 'Id.', value: 'id' },
				{ text: 'Nr.', value: 'numeroObra' },
				{ text: 'Data Prevista Inauguracao', value: 'dataPrevistaInauguracao' },
				//{ text: 'No. Emenda Anulada', value: 'emenda.numeroEmenda' },
				//{ text: 'Ano Exercício', value: 'emenda.anoExercicio' },
				//{ text: 'Esfera', value: 'emenda.esfera.descricao' },
				// { text: 'Valor Fixado Final (R$)', value: 'valorFixadoFinal$' }
				{ text: '', value: 'actions', sortable: false }

			],
			noDataMessage:
				'Não foram encontradas obras para o exercício.',
			itemsPerPage: 10,
			page: 1,
			esfera: null,
			anoExercicio: null,
			esferaItems: [],
			anoExercicioItems: [],
			impressao : false
		};
	},
	
	components: {VPageHeader},

	async created() {
		this.$root.colorHeader = "red";
		this.$root.titleHeader = "Cadastro de Obras";
		this.anoExercicio = this.$root.anoSelecionado;

		//this.fetchEsferaItems();
		this.fetchObras();
	},
	
	watch: {
		searchText() {
			this.page = 1;
		}
	},

	methods: {

		// async fetchEsferaItems() {
		// 	try {
		// 		this.esferaItems = await this.$fetch.get('parlamentares/esferas');
		// 		this.esferaItems.splice(0, 0, { id: null, descricao: 'Todos' });
		// 		this.esfera = this.esferaItems[0];
		// 	} catch (err) {
		// 		this.$root.dialog = {
		// 			title: 'Não foi possível carregar esferas',
		// 			msg: err.msg
		// 		};
		// 	}
		// },

		novo() {
			this.$router.push('/obras/novo');
		},
		
		rowClick(item) {
			if (!this.impressao) {
				this.$router.push(`/obras/${item.id}`);
			}
			this.impressao = false;
		},

		async fetchObras() {
			try {
				let obras = await this.$fetch.get('obras'
					//{ anoExercicio: this.anoExercicio
					//idEsfera: this.esfera.id, }
				);	
				this.obras = obras;
			} catch (err) {
				this.noDataMessage = err.msg;
			}
		},


		// adaptar para obras
		customSort(items, index, isDesc) {
			items.sort((a, b) => {
				if (index[0] && index[0].slice(-1) === '$') {
					if (!isDesc[0]) {
						return a[index[0].slice(0, -1)] < b[index[0].slice(0, -1)] ? -1 : 1;
					} else {
						return b[index[0].slice(0, -1)] < a[index[0].slice(0, -1)] ? -1 : 1;
					}
				} else if (index[0] == 'dataDecreto') {
					if (!isDesc[0]) {
						return parseDate(b[index], 'dd/MM/yyyy', new Date()) - parseDate(a[index], 'dd/MM/yyyy', new Date());
					} else {
						return parseDate(a[index], 'dd/MM/yyyy', new Date()) - parseDate(b[index], 'dd/MM/yyyy', new Date());
					}
				} else if (a[index]) {
					if (!isDesc[0]) {
						return a[index] < b[index] ? -1 : 1;
					} else {
						return b[index] < a[index] ? -1 : 1;
					}
				}
				else {
					// campos "filhos" tem que fazer a ordenação na mão
					if ((index[0] == 'emenda.numeroEmenda') || (index[0] == 'emenda.anoExercicio'))
					{
						var campoA, campoB, ordem;

						if (index[0] == 'emenda.numeroEmenda')
						{
							campoA = a['emenda'];
							campoB = b['emenda'];

							ordem = 'numeroEmenda';
						}

						if (index[0] == 'emenda.anoExercicio')
						{
							campoA = a['emenda'];
							campoB = b['emenda'];

							ordem = 'anoExercicio'
						}

						if (!isDesc[0]) {
							return campoA[ordem] < campoB[ordem] ? -1 : 1;
						} else {
							return campoB[ordem] < campoA[ordem] ? -1 : 1;
						}
					}
					if (index[0] == 'emenda.esfera.descricao')
					{
						var campoA1, campoB1, campoA2, campoB2, ordem1;

						campoA1 = a['emenda'];
						campoB1 = b['emenda'];

						campoA2 = campoA1['esfera'];
						campoB2 = campoB1['esfera'];


						ordem1 = 'descricao';

						if (!isDesc[0]) {
							return campoA2[ordem1] < campoB2[ordem1] ? -1 : 1;
						} else {
							return campoB2[ordem1] < campoA2[ordem1] ? -1 : 1;
						}
					}
				}
			});

			return items;
		},

		temFuncao(fn) {
			return (
				this.$root.usuarioLogado &&
				this.$root.usuarioLogado.funcoes &&
				this.$root.usuarioLogado.funcoes.includes(fn)
			);
		}

	}
};
</script>

<style scoped>
.head-tile {
	margin: -10px -10px 0 -10px;
}

.row-pointer >>> tbody tr :hover {
	cursor: pointer;
}
.situacao {
	font-weight: bold;
	color: orangered;
}
.emendas {
	font-weight: bold;
	color: purple;
}
.decretos {
	font-weight: bold;
	color: purple;
}
.info-despacho {
	text-align: center;
	font-size: 80%;
}
</style>
